/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Groups_TitleInputs */



/**
* | output |
* | --- |
* | "No groups yet" |
*
* @param {Team_Manager_No_Groups_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_groups_title = /** @type {((inputs?: Team_Manager_No_Groups_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Groups_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun groupe pour l'instant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Gruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ancora nessun gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пока нет групп")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay grupos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无群组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("まだグループがありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी कोई समूह नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ainda sem grupos")
	return /** @type {LocalizedString} */ ("No groups yet")
});